export function getStartAndEndOfMonth() { // Obtner el inico y el fin del mes actual
 const now = new Date();
 const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // Primer día del mes
 const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Último día del mes

 return {
   start: firstDay.toISOString().split("T")[0], // Formato YYYY-MM-DD
   end: lastDay.toISOString().split("T")[0],
 };
};

export function getToday() {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

  return {
    start: startOfToday.toISOString().split("T")[0],
    end: startOfTomorrow.toISOString().split("T")[0]
  };
}

export const getCurrentMonth = () => {
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  return {
    start: startOfMonth.toISOString().split("T")[0],
    end: endOfMonth.toISOString().split("T")[0]
  };
};

export function getCurrentWeek() {
  const now = new Date();
  
  // Obtener el día de la semana (0 = Domingo, 1 = Lunes, ..., 6 = Sábado)
  const dayOfWeek = now.getDay();
  
  // Calcular el lunes de la semana actual
  // Si hoy es domingo (0), retrocedemos 6 días para llegar al lunes anterior
  // Si hoy es lunes (1), no retrocedemos
  // Si hoy es martes (2), retrocedemos 1 día, etc.
  const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(now);
  monday.setDate(now.getDate() - mondayOffset);
  monday.setHours(0, 0, 0, 0);
  
  // Calcular el sábado (6 días después del lunes)
  const saturday = new Date(monday);
  saturday.setDate(monday.getDate() + 5);
  saturday.setHours(23, 59, 59, 999);
  
  return {
    start: monday.toISOString().split("T")[0],
    end: saturday.toISOString().split("T")[0]
  };
}

export function getTodayWithHours() {
  const now = new Date();
  
  // Inicio del día en UTC (05:00 UTC = 00:00 hora Perú)
  const startOfToday = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    5,  // 05:00 UTC
    0,
    0,
    0
  ));
  
  // Fin del día en UTC (04:59 UTC del día siguiente = 23:59 hora Perú)
  const endOfToday = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() + 1,
    4,  // 04:59 UTC
    59,
    59,
    999
  ));

  return {
    start: startOfToday,
    end: endOfToday
  };
}
